import React from 'react';
import './GenericModal.css';

const GenericModal = ({ show, onClose, header, body, footer, size = 'md' }) => {
  if (!show) return null;

  return (
    <div className="modern-invite-overlay">
      <div className={`modern-invite-modal modal-size-${size}`}>
        <div className="modern-modal-header generic-modal-header">
          <button
            className="modern-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
          {header}
        </div>

        <div className="modern-modal-body">{body}</div>

        <div className="modern-modal-actions">{footer}</div>
      </div>
    </div>
  );
};

export default GenericModal;
